module.exports = __webpack_public_path__ + "img/floor2_7.478dfb34.jpg";